<template>
  <div>
    <div class="app-title">
      <div>
        <h1><i class="fas fa-pencil-alt"></i> Report</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">Title</h3>
            <p>
              <button @click="print" type="button" class="btn btn-outline-success">
                <i class="fas fa-print"></i> พิมพ์
              </button>
            </p>
          </div>
          <div class="tile-body">
            <div id="printMe">
              <div class="text-center">
                <h4>ตารางปฏิบัติงานนอกเวลาราชการ งานสารสนเทศทางการแพทย์</h4>
                <h5>โรงพยาบาลวานรนิวาส จังหวัดสกลนคร</h5>
                <p>
                  <span>ชื่อ:</span> นายบัญชาชัย แพงพิมพ์โล้
                  <span>ตำแหน่ง:</span> นักวิชาการคอมพิวเตอร์
                </p>
              </div>
              <table class="table table-striped table-inverse table-bordered">
                <thead class="thead-inverse text-center">
                  <tr>
                    <th>#</th>
                    <th>date</th>
                    <th>details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row"></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td scope="row"></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <div class="text-center foot">
                <p>(name)</p>
                <p>position</p>
                <p class="mt-5">(name)</p>
                <p>position</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">Title</h3>
            <p>
              <button @click="modal.show()" type="button" class="btn btn-outline-primary">
                <i class="fas fa-plus"></i> เพิ่มภารงาน
              </button>
            </p>
          </div>
          <div class="tile-body">
            <div class="form-group">
              <label for="">date</label>
              <input type="text" class="form-control" placeholder="">
            </div>
            <div class="form-group">
              <label for="">details</label>
              <textarea class="form-control" name="" id="" rows="3"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ฟอร์มเพิ่มหน่วยงาน</h5>
            <button @click="modal.hide()" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleSubmit" ref="form" class="needs-validation" novalidate>
              <div class="form-group">
                <label for="">ชื่อบทบาท</label>
                <input v-model="data.role_name" type="text" class="form-control" placeholder="ชื่อบทบาท" required />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button v-if="!is_edit" @click="handleSubmit" type="button" class="btn btn-primary">
              <i class="fas fa-save    "></i>
              บันทึกข้อมูล
            </button>
            <button v-else @click="update" type="button" class="btn btn-warning">
              <i class="fas fa-edit"></i>

              แก้ไขข้อมูล
            </button>
            <button type="button" class="btn btn-secondary" @click="modal.hide()">
              <i class="fas fa-times"></i>

              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from "lodash";
import { Modal } from "bootstrap";

export default {
  data() {
    return {
      data: {},
      modal: null,
      repairs: "",
      users: "",
      name: this.$route.name,
      username: JSON.parse(localStorage.getItem("user")).user.name,
      position: JSON.parse(localStorage.getItem("user")).user.position,
    };
  },
  methods: {
    async print() {
      await this.$htmlToPaper("printMe");
    },

  },
  computed: {
  },
  mounted() {
    this.modal = new Modal(this.$refs.exampleModal);
  },
  created() {
    console.log(this.$store.state.auth);
  },
};
</script>

<style>
@media print {
  body * {
    visibility: hidden;
  }

  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }

  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>